import React from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Credentials from "@/components/sections/Credentials";
import Services from "@/components/sections/Services";
import Differentiators from "@/components/sections/Differentiators";
import HowItWorks from "@/components/sections/HowItWorks";
import Pricing from "@/components/sections/Pricing";
import ContactForm from "@/components/sections/ContactForm";
import Location from "@/components/sections/Location";
import Footer from "@/components/sections/Footer";
import FloatingWhatsapp from "@/components/sections/FloatingWhatsapp";

const Landing = () => {
  return (
    <main data-testid="landing-root" className="bg-[#FAFAFA] text-[#0A1128] overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <Credentials />
      <Services />
      <Differentiators />
      <HowItWorks />
      <Pricing />
      <ContactForm />
      <Location />
      <Footer />
      <FloatingWhatsapp />
    </main>
  );
};

export default Landing;
